import { StepNav } from 'slab'

type QuoteCreationStep = 'prospect' | 'employees' | 'currentbenefits' | 'strategy' | 'suggestions' | 'configure'

type QuoteCreationStepDetails = {
  step: QuoteCreationStep
  label: string
  path: string
}

type Props = {
  steps: QuoteCreationStepDetails[]
  currentStep: QuoteCreationStep
}

export default function QuoteFlowSideNav ({ steps, currentStep }: Props) {
  const currentStepIndex = steps.findIndex((step) => step.step === currentStep)

  return (
    <div className='m-6 min-w-40'>
      <StepNav>
        {steps.map((step, index) => (
          <StepNav.Step
            key={step.step}
            name={step.label}
            as='a'
            href={step.path}
            active={index === currentStepIndex}
            available={index < currentStepIndex}
            complete={index < currentStepIndex}
          />
        ))}
      </StepNav>
    </div>
  )
}
